import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import { ClipLoader } from 'react-spinners';

import UserDucks from "stores/ducks/User.duck";
import Checkout from './campaign/SellPage/Checkout';

interface IDashboardOverviewProps {
	isLoggedIn?: boolean;
	isLoading?: boolean;
}

/**
 * When the "/" route is accessed.
 */
class LandingPage extends React.Component<IDashboardOverviewProps | any> {
	public render() {

		const url = window.location.href.toLowerCase();
		const urlItems = url.split('/')
		const subdomain = urlItems[2].split('.')[0]
		const username = (urlItems[3] !== undefined && urlItems[3] !== null && urlItems[3] !== '') ? urlItems[3] : undefined

		// If loading then return the loader
		if (this.props.isLoading) {
			return <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
				<div className="p-4 w-100 text-center" style={{ paddingTop: '50px' }}>
					<ClipLoader color={"#000"} loading={true} />
				</div>
			</div>
		}

		if (subdomain !== 'app' && subdomain !== 'localhost:3000' && subdomain !== 'test') {
			return <Checkout subdomain={subdomain} username={username} />
		} else if (this.props.isLoggedIn === true) {
			window.location.pathname = '/campaigns';
			return null;
		} else if (window.location.pathname.includes('/sell/')) {
			return null;
		} else {
			return <Redirect to="/login" />;
		}
	}
}

const mapStateToProps = state => {
	return {
		isLoggedIn: UserDucks.isAuthenticated(state),
		isLoading: UserDucks.getLoading(state)
	};
};
export default connect(mapStateToProps)(LandingPage);



// WEBPACK FOOTER //
// ./src/pages/Landing.page.tsx